import React, { useEffect, useState } from "react";
import Nav from "../nav";
import Header from "../../../common/header/header";
import { MultiSelect, rem, Button } from "@mantine/core";
import { IconCalendar, IconChevronDown } from "@tabler/icons-react";
import { DatePickerInput } from "@mantine/dates";
import { Link, useLocation } from "react-router-dom";
import { pdf } from "../../../api/baseUrl";

function AnalystCalls() {
  const [companyvalue, setCompanyValue] = useState();
  const [ratingvalue, setRatingValue] = useState();
  const [sectorvalue, setSectorValue] = useState();
  const [datevalue, setDateValue] = useState();
  const [filter, setFilter] = useState();
  const icon = <IconChevronDown size={16} />;
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const calendaricon = (
    <IconCalendar style={{ width: rem(18), height: rem(18) }} stroke={1.5} />
  );

  useEffect(() => {
    fetch(`https://www.cms.akseerresearch.com/api/sellsideresearch`, {
      headers: {
        "Access-Control-Allow-Origin": "*",
        // Authorization: `Bearer ${cookies?.accessToken}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        // setFilings(data.data);
        setFilter(data.filter);
        // setCheck(true);
      })
      .catch((error) => {
        console.error("Error fetching data:", error); // Debugging
      });
  }, []);

  return (
    <>
      <Header />
      <div className="investment-main analyst">
        <div className="row investmentboxed" style={styles.navWidth}>
          <Nav nopadding={true} />
        </div>
      </div>
      <div className="research-report-main">
        <div className="container container_box">
          <div className="research-select-field research-second-box">
            <div className="research-second-line">
              <MultiSelect
                data={filter.company}
                searchable
                rightSection={icon}
                placeholder="Select Company"
                label="Company"
                value={companyvalue}
                onChange={setCompanyValue}
              />
            </div>
            <div className="research-second-line">
              <MultiSelect
                data={["Buy", "Sell", "Hold"]}
                searchable
                rightSection={icon}
                placeholder="Select Rating"
                label="Rating"
                value={ratingvalue}
                onChange={setRatingValue}
              />
            </div>
            <div className="research-second-line">
              <MultiSelect
                data={["Cement", "Fertilizer", "Banks"]}
                searchable
                rightSection={icon}
                placeholder="Select Sector"
                label="Sector"
                value={sectorvalue}
                onChange={setSectorValue}
              />
            </div>
            <div className="research-second-line">
              <DatePickerInput
                clearable
                type="range"
                value={datevalue}
                onChange={setDateValue}
                valueFormat="DD MMM, YYYY"
                placeholder="Select Date Range"
                label="Date Range"
                className="news-date-picker"
                mx="auto"
                icon={<IconCalendar size="1.1rem" stroke={1.5} />}
              />
            </div>
            <Button className="research-search-btn">Search</Button>
          </div>
          <div className="research-report-tbl ask-table-format">
            <table className="table table-responsive">
              <thead>
                <tr>
                  <th>Company</th>
                  <th>Date</th>
                  <th>Target Price</th>
                  <th>Upside %</th>
                  <th>Sector</th>
                  <th>Provider</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>LUCK</td>
                  <td>April 28, 2016</td>
                  <td>210</td>
                  <td>
                    <span className="cementtext">20.28</span>
                  </td>
                  <td>
                    <span className="cementtext">Cement</span>
                  </td>
                  <td>JS Research</td>
                  <td className="center-align">
                    <Link target="_blank" download>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pdf,
                        }}
                      />
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>ENGRO</td>
                  <td>March 13, 2014</td>
                  <td>62</td>
                  <td>
                    <span className="cementtext">26.87</span>
                  </td>
                  <td>
                    <span className="cementtext">Fertilizer</span>
                  </td>
                  <td>Alpha Capital (Pvt) Ltd.</td>
                  <td className="center-align">
                    <Link target="_blank" download>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pdf,
                        }}
                      />
                    </Link>
                  </td>
                </tr>
                <tr>
                  <td>UBL</td>
                  <td>December 19, 2013</td>
                  <td>185</td>
                  <td>
                    <span className="cementtext">7.87</span>
                  </td>
                  <td>
                    <span className="cementtext">Bank</span>
                  </td>
                  <td>JS Research</td>
                  <td className="center-align">
                    <Link target="_blank" download>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: pdf,
                        }}
                      />
                    </Link>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}

const styles = {
  companylogo: {
    width: "280px",
    float: "right",
  },
  navWidth: {
    width: "100%",
    fontSize: "14px",
    margin: "auto",
    marginBottom: "10px",
    justifyContent: "space-between",
  },
  companyname: {
    width: "100%",
    fontSize: "14px",
    justifyContent: "space-between",
    marginLeft: "0px",
    marginRight: "0px",
  },
};

export default AnalystCalls;
